/**
 * Network Security skill hints for the network map (UI-only, never touch the
 * scorer): Lv1 tells how many nodes are risky, Lv2 reveals the recommended
 * measure for the first risky node, Lv3 for every risky node.
 */
export function riskyNodeCount(nodes: readonly { isRisky: boolean }[]): number {
  return nodes.filter((node) => node.isRisky).length;
}

export function revealedMeasureNodeIds(
  nodes: readonly { id: string; isRisky: boolean }[],
  level: number,
): string[] {
  if (level < 2) {
    return [];
  }
  const risky = nodes.filter((node) => node.isRisky).map((node) => node.id);
  return level >= 3 ? risky : risky.slice(0, 1);
}
